import { BaseTracer } from "@app-services/base-tracer.service";
import { pushToTraceBuffer } from "@storage/trace-buffer";

class ShallowTracer extends BaseTracer {
    // Use this tracer when you don't want to persist the traces to the storage immediately
    // (eg. when the storage is not available).

    protected override storeTrace(trace: string): void {
        pushToTraceBuffer(trace);
    }
}

export const shallowTracer: BaseTracer = new ShallowTracer();